import { render, staticRenderFns } from "./WorkBookCultureTraits.vue?vue&type=template&id=9aebbfc4&scoped=true&"
import script from "./WorkBookCultureTraits.vue?vue&type=script&lang=js&"
export * from "./WorkBookCultureTraits.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookCultureTraits.vue?vue&type=style&index=0&id=9aebbfc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aebbfc4",
  null
  
)

export default component.exports